import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FromulariodespachoComponent } from 'app/components/servicio-medico/despacho/subdespacho/fromulariodespacho/fromulariodespacho.component';
import { ServiciosService } from 'app/services/servicios.service';

@Component({
  selector: 'app-movil-despacho',
  templateUrl: './movil-despacho.component.html',
  styleUrls: ['./movil-despacho.component.scss']
})
export class MovilDespachoComponent implements OnInit {

  public movil;
  public datosMovil;
  public titulo;

  constructor(public dialogRef: MatDialogRef<FromulariodespachoComponent>, @Inject(MAT_DIALOG_DATA) private datos, private serviciosService: ServiciosService) { }
 
  ngOnInit() {
      if (this.datos.movil) {
        this.movil = this.datos.movil;
        this.serviciosService.movilDespacho(this.movil).subscribe((data: any) => {
          console.log(data);
          this.datosMovil = data;
        });
      } else {
          this.datosMovil = this.datos.servicios;
          this.titulo = this.datos.titulo;
          console.log(this.datos);
      }

  }


}
